@if (isVisible()) {
  <div class="cookie-banner">
    <div class="cookie-content">
      <div class="cookie-text">
        {{ 'CookieNotice.Text' | translate }}
      </div>

      <app-legal-links></app-legal-links>
    </div>

    <button class="button-red" (click)="close()">OK</button>
  </div>
}